// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"zwCw50","WithBorder":"FotDjr","Icon":"IuJbE9"};